export const useSidebar = () => {
  const isCollapsed = useState('sidebar-collapsed', () => true)

  const toggle = () => {
    isCollapsed.value = !isCollapsed.value
  }

  const collapse = () => {
    isCollapsed.value = true
  }

  const expand = () => {
    isCollapsed.value = false
  }

  const setCollapsed = (value: boolean) => {
    isCollapsed.value = value
  }

  return {
    isCollapsed,
    toggle,
    collapse,
    expand,
    setCollapsed,
  }
}
